<app-header></app-header>
<app-sidebar
  ativo="Gestao"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Configurações"
      Pagina="Configurações"
    ></app-breadcrumb>
    <div class="row">
      <div class="col-md-3 menu">
        <div class="item-menu row border-top" [ngClass]="{'active': configEmail}" (click)="exibirConfiguracoesEmail()">
          <div class="col-md-8">
            Emails
          </div>
          <div class="icone-menu col-md-4 text-right">
            <div class="fa fa-chevron-right"></div>
          </div>
        </div>
        <div class="item-menu row border-top" [ngClass]="{'active': configWhatsapp}" (click)="exibirConfiguracoesWhatsapp()">
          <div class="col-md-8">
            Whatsapp
          </div>
          <div class="icone-menu col-md-4 text-right">
            <div class="fa fa-chevron-right"></div>
          </div>
        </div>
      </div>
      <div class="col-md-9">
        <div class="card card-primary p-3">
          <div class="card-title titulo-card">{{title}}</div>
          <hr>
          <div class="card-body">
            <div class="row" *ngIf="configEmail">
              <app-configuracao-email></app-configuracao-email>
            </div>

            <div class="row" *ngIf="configWhatsapp">
              <app-configuracao-whatsapp></app-configuracao-whatsapp>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
